import { Button, Divider, Modal, Space, Table, Tooltip } from 'antd';
import { DownCircleTwoTone } from '@ant-design/icons';
import { DefaultPaginationConfig } from '../constants/pagination';
import { Link } from 'react-router-dom';

const ArchivoList = (props) => {
    const { isModalOpen, archivos, onCancel } = props;

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'nombreArchivo',
            sorter: (a, b) => (a.nombreArchivo < b.nombreArchivo ? -1 : 1),
            width: '100%',
        },
        {
            title: 'Acción',
            dataIndex: 'accion',
            render: (_, record) => (
                <Space size={0}>
                    <Tooltip title='Abrir'>
                        <Link h to={record.url} download>
                            <DownCircleTwoTone />
                        </Link>
                    </Tooltip>
                </Space>
            ),
        },
    ];

    return (
        <>
            <Modal
                open={isModalOpen}
                title='Archivos'
                onCancel={onCancel}
                destroyOnClose={true}
                footer={[
                    <Button key='back' onClick={onCancel}>
                        Cancelar
                    </Button>,
                ]}
                style={{ top: 20 }}
            >
                <Divider></Divider>

                <div className='row'>
                    <div className='col-lg-12 pb-3'>
                        <Table
                            rowKey={(record) => record.idDetalleOportunidad}
                            dataSource={archivos}
                            columns={columns}
                            pagination={{
                                ...DefaultPaginationConfig,
                            }}
                        ></Table>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ArchivoList;
